// extracted by mini-css-extract-plugin
export default {"scrollToTopButton":"ScrollToTop_scrollToTopButton__6Gkes"};